import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utilities';

const initialState = {
  clientes: {
    clientes: [],
    loading: false,
    error: null
  },
  clientSelected: {
    clienteId: '',
    clienteIdPg: 0,
    cuit: '',
    nombreFantasia: '',
    razonSocial: '',
    baja: false
  },
  clientesInfoMinima: {
    clientes: [],
    loading: false,
    error: null,
    estaCargado: false,
  },
  clienteById: {
    cliente: {},
    loading: false,
    error: null,
    clientSelected: false,
  },
  clienteCabeceraById: {
    cliente: null,
    loading: false,
    error: null,
  },
  ultimaCompra: {
    fecha: "",
    idComproba: "",
    nombre: "",
    referencia: 0,
    total: 0,
    loading: false,
    error: null,
  },
  cuentaCorriente: {
    comprobantes: [],
    loading: false,
    error: null,
    estaCargado: false,
  },  
  evolucionComprasMensual: {
    ventas: [],
    ventasDataTable: [],
    total: 0,
    loading: false,
    estaCargado: false,
    error: null
  },
};

//#region loadClientes
const loadClientesStart = (state) => {
  return updateObject(state, {
    clientes: updateObject(state.clientes, {
      loading: true
    })
  });
};

const loadClientesSuccess = (state, clientes) => {
  return updateObject(state, {
    clientes: updateObject(state.clientes, {
      clientes,
      loading: false
    })
  });
};

const loadClientesFail = (state, error) => {
  return updateObject(state, {
    clientes: updateObject(state.clientes, {
      loading: false,
      error
    })
  });
};
//#endregion

//#region Client selected
const clientSelected = (state, client) => {
  return updateObject(state, {
    clientSelected: updateObject(state.clientSelected, {
      clienteId: client.clienteId,
      clienteIdPg: client.clienteIdPg,
      cuit: client.cuit,
      nombreFantasia: client.nombreFantasia,
      razonSocial: client.razonSocial,
      baja: client.baja
    })
  });
};
//#endregion

//#region loadClienteById
const loadClienteByIdStart = (state) => {
  return updateObject(state, {
    clienteById: updateObject(state.clienteById, {
      loading: true,
    }),
  });
};

const loadClienteByIdSuccess = (state, cliente) => {
  return updateObject(state, {
    clienteById: updateObject(state.clienteById, {
      loading: false,
      cliente,
      clientSelected: true,
      error: null,
    }),
  });
};

const loadClienteByIdFail = (state, error) => {
  return updateObject(state, {
    clienteById: updateObject(state.clienteById, {
      loading: false,
      error,
      clientSelected: false,
    }),
  });
};

const unmountClienteById = (state) => {
  return updateObject(state, {
    clienteById: updateObject(state.clienteById, {
      loading: false,
      cliente: {},
      error: null,
      clientSelected: false,
    }),
  });
};
//#endregion

//#region loadUltimaCompra
const loadUltimaCompraStart = (state) => {
  return updateObject(state, {
    ultimaCompra: updateObject(state.ultimaCompra, {
      loading: true,
    }),
  });
};

const loadUltimaCompraSuccess = (
  state,
  fecha,
  idComproba,
  nombre,
  referencia,
  total
) => {
  return updateObject(state, {
    ultimaCompra: updateObject(state.ultimaCompra, {
      fecha,
      idComproba,
      nombre,
      referencia,
      total,
      loading: false,
      error: null,
    }),
  });
};

const loadUltimaCompraFail = (state, error) => {
  return updateObject(state, {
    ultimaCompra: updateObject(state.ultimaCompra, {
      loading: false,
      fecha: "",
      idComproba: "",
      nombre: "",
      referencia: 0,
      total: 0,
      error,
    }),
  });
};

const clearUltimaCompra = (state) => {
  return updateObject(state, {
    ultimaCompra: updateObject(state.ultimaCompra, {
      fecha: "",
      idComproba: "",
      nombre: "",
      referencia: 0,
      total: 0,
      loading: false,
      error: null,
    }),
  });
};
//#endregion

//#region Cuenta Corriente
const loadCuentaCorrienteClienteStart = (state) => {
  return updateObject(state, {
    cuentaCorriente: updateObject(state.cuentaCorriente, {
      loading: true,
      estaCargado: false,
    }),
  });
};

const loadCuentaCorrienteClienteSuccess = (state, comprobantes) => {
  return updateObject(state, {
    cuentaCorriente: updateObject(state.cuentaCorriente, {
      loading: false,
      comprobantes,
      error: null,
      estaCargado: true,
    }),
  });
};

const loadCuentaCorrienteClienteFail = (state, error) => {
  return updateObject(state, {
    cuentaCorriente: updateObject(state.cuentaCorriente, {
      comprobantes: [],
      loading: false,
      error,
      estaCargado: true,
    }),
  });
};

const clearCuentaCorrienteCliente = (state) => {
  return updateObject(state, {
    cuentaCorriente: updateObject(state.cuentaCorriente, {
      comprobantes: [],
      loading: false,
      error: null,
      estaCargado: false,
    }),
  });
};
//#endregion

//#region load evolucion de compras
const loadEvolucionDeComprasMensualStart = (state) => {
  return updateObject(state, {
    evolucionComprasMensual: updateObject(state.evolucionComprasMensual, {
      ventas: [],
      ventasDataTable: [],
      total: 0,
      loading: true,
      estaCargado: false,
      error: null
    })
  });
};

const loadEvolucionDeComprasMensualSuccess = (state, ventas, ventasDataTable, total) => {
  return updateObject(state, {
    evolucionComprasMensual: updateObject(state.evolucionComprasMensual, {
      ventas,
      ventasDataTable,
      total,
      loading: false,
      estaCargado: true
    })
  });
};

const loadEvolucionDeComprasMensualFail = (state, error) => {
  return updateObject(state, {
    evolucionComprasMensual: updateObject(state.evolucionComprasMensual, {
      loading: false,
      error: error,
      estaCargado: true
    })
  });
};

const clearEvolucionDeComprasMensual = (state) => {
  return updateObject(state, {
    evolucionComprasMensual: updateObject(state.evolucionComprasMensual, {
      ventas: [],
      ventasDataTable: [],
      total: 0,
      loading: false,
      estaCargado: false,
      error: null
    })
  });
};
//#endregion

const reducer = (state = initialState, action) => {
  switch (action.type) {
    //#region LOAD CLIENTES
    case actionTypes.LOAD_CLIENTES_START:
      return loadClientesStart(state);
    case actionTypes.LOAD_CLIENTES_SUCCESS:
      return loadClientesSuccess(state, action.clientes);
    case actionTypes.LOAD_CLIENTES_FAIL:
      return loadClientesFail(state, action.error);
    //#endregion

    //#region CLIENT SELECTED
    case actionTypes.CLIENT_SELECTED:
      return clientSelected(state, action.client);
    //#endregion

    //#region LOAD CLIENTE BY ID
    case actionTypes.LOAD_CLIENTE_BY_ID_START:
      return loadClienteByIdStart(state);
    case actionTypes.LOAD_CLIENTE_BY_ID_SUCCESS:
      return loadClienteByIdSuccess(state, action.cliente);
    case actionTypes.LOAD_CLIENTE_BY_ID_FAIL:
      return loadClienteByIdFail(state, action.error);
    case actionTypes.UNMOUNT_CLIENTE_BY_ID:
      return unmountClienteById(state);
    //#endregion

    //#region LOAD ÚLTIMA COMPRA BY CLIENTE
    case actionTypes.LOAD_ULTIMA_COMPRA_BY_CLIENTE_START:
      return loadUltimaCompraStart(state);
    case actionTypes.LOAD_ULTIMA_COMPRA_BY_CLIENTE_SUCCESS:
      return loadUltimaCompraSuccess(state, action.fecha, action.idComproba, action.nombre, action.referencia, action.total);
    case actionTypes.LOAD_ULTIMA_COMPRA_BY_CLIENTE_FAIL:
      return loadUltimaCompraFail(state, action.error);
    case actionTypes.CLEAR_ULTIMA_COMPRA_BY_CLIENTE:
      return clearUltimaCompra(state);
    //#endregion
    
    //#region LOAD CUENTA CORRIENTE CLIENTE
    case actionTypes.LOAD_CUENTA_CORRIENTE_CLIENTE_START:
      return loadCuentaCorrienteClienteStart(state);
    case actionTypes.LOAD_CUENTA_CORRIENTE_CLIENTE_SUCCESS:
      return loadCuentaCorrienteClienteSuccess(state, action.comprobantes);
    case actionTypes.LOAD_CUENTA_CORRIENTE_CLIENTE_FAIL:
      return loadCuentaCorrienteClienteFail(state, action.error);
    case actionTypes.CLEAR_CUENTA_CORRIENTE_CLIENTE:
      return clearCuentaCorrienteCliente(state);
    //#endregion
    
    //#region LOAD EVOLUCIÓN DE VENTAS 
    case actionTypes.LOAD_EVOLUCION_DE_COMPRAS_START:
      return loadEvolucionDeComprasMensualStart(state);
    case actionTypes.LOAD_EVOLUCION_DE_COMPRAS_SUCCESS:
      return loadEvolucionDeComprasMensualSuccess(state, action.ventas, action.ventasDataTable, action.totalVentas);
    case actionTypes.LOAD_EVOLUCION_DE_COMPRAS_FAIL:
      return loadEvolucionDeComprasMensualFail(state, action.error);
    case actionTypes.CLEAR_EVOLUCION_DE_COMPRAS:
      return clearEvolucionDeComprasMensual(state);
    //#endregion
    
    default:
      return state;
  }
};

export default reducer;
